import React, {useState, useEffect} from 'react';
import { QRCode } from 'react-qrcode-logo';

function ProductCard(props) {
    const [showModal, setShowModal] = React.useState(false);

    //TODO: add some security filter to retrieve info based on the domain or apikey?
   //useEffect(() => {
   //    if(showModal) {
            // axiosInstance.get(`api/public/v1/qr/${props.code}`).then((result) => {
            //     if(result?.status === 200) {
            //         setProduct(result.data);
            //         setCertifications(result.data.certifications);
            //     }
            // });
    //    }
    //}, [showModal]);

    return (
        <div style={{fontFamily: "Nunito Sans"}} className='text-gray-500'>
        <div className="rounded overflow-hidden" style={{width: "265px", margin: "20px"}}>
            <div style={{marginLeft: "65px"}}>
                <QRCode size={90} value={`${process.env.REACT_APP_HOST_BASE_URL}/public/qr/${props?.code}`}/>
            </div>
            <button type="button" onClick={() => setShowModal(true)} class="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 hover:border-gray-500 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-full text-sm px-3 py-2 mt-2 text-center inline-flex items-center">
                <img style={{height: "22px"}} className='mr-2' src={process.env.REACT_APP_WIDGET_BASE_URL + "/img/xylene-icon.png"} alt="Xylene Logo"/>
                See Digital Product Passport
            </button>
        </div>
        {showModal && props ? (
            <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none" style={{zIndex: 99999}}>
                <div className="relative my-6 mx-auto" style={{width: "90%", height: "90%"}}>
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none" style={{height: "100%"}}>
                        {/*header*/}
                        <div className="flex items-start justify-between p-6 pb-2 pt-3 border-b border-solid border-gray-200 rounded-t" style={{fontFamily: "Nunito Sans"}}>
                        {/* <h3 className="text-2xl font-semibold">
                            {"Xylene Product Journey"}
                        </h3> */}
                        <div className='flex'>
                            <div className='m-auto mr-2 text-sm '>Digital Product Passport by</div>
                            <img style={{height: "30px"}} src={process.env.REACT_APP_WIDGET_BASE_URL + "/img/xylene-logo.png"} alt="Xylene Logo"/>
                        </div>
                        <button className="ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none" onClick={() => setShowModal(false)} >
                            <span className="bg-transparent text-gray-400 h-6 w-6 text-2xl block outline-none focus:outline-none"> × </span>
                        </button>
                        </div>
                        {/*body*/}
                        <iframe title="Xylene - Digital Product Passport" height={"100%"} src={`${process.env.REACT_APP_HOST_BASE_URL}/public/qr/${props?.code}`} style={{background: `url(${process.env.REACT_APP_WIDGET_BASE_URL}/img/loading.gif) center center no-repeat`}}></iframe>
                    </div>
                </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black" style={{display: "block"}}></div>
            </>
        ) : null}
        </div>
    );
}

export default ProductCard;
